import { Button, CreateAlert, InputWraper, useForm } from 'modules';
import moment from 'moment';
import React, { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

import { Routes } from '../../../../AppRoutes';
import { InputDateTime, InputText } from '../../../../components';
import { InputImageSingle } from '../../../../components/single-image';
import { Tabs } from '../../../../components/tabs';
import { translate } from '../../../../languages';
import { ConfigService } from '../../../../services/config/config.service';
import { useSelector } from '../../../../store';
import { EditorForm } from '../editor';

export const EditAnnouncementPage: FC = (props) => {
  const navigate = useNavigate();
  const detailAnnouncement = useSelector((state) => state.detailAnnouncement);
  const { announcementId, title, content, image, expirationDate } =
    detailAnnouncement;

  const [newContent, setNewContent] = useState<any>({
    'en-US': '',
    'vi-VN': '',
    'ko-KR': '',
    'zh-CN': '',
    'hi-IN': '',
    'id-ID': '',
    'fr-FR': '',
    'es-ES': '',
  });

  useEffect(() => {
    if (!detailAnnouncement) navigate(Routes.Announcement.path);
    setNewContent(() => {
      return content;
    });
  }, [detailAnnouncement]);

  const { handleSubmit, getInputProps, isSubmitting } = useForm({
    structure: [
      {
        name: 'announcementId',
        defaultValue: announcementId,
        isDisabled: true,
      },
      {
        name: 'titleEN',
        defaultValue: title?.['en-US'],
        validate: Yup.string().required(translate('must-be-provided')),
      },
      {
        name: 'titleVI',
        defaultValue: title?.['vi-VN'],
        // validate: Yup.string().required(translate("must-be-provided")),
      },
      {
        name: 'titleKO',
        defaultValue: title?.['ko-KR'],
        // validate: Yup.string().required(translate("must-be-provided")),
      },
      {
        name: 'titleZH',
        defaultValue: title?.['zh-CN'],
        // validate: Yup.string().required(translate("must-be-provided")),
      },
      {
        name: 'titleHI',
        defaultValue: title?.['hi-IN'],
        // validate: Yup.string().required(translate("must-be-provided")),
      },
      {
        name: 'titleID',
        defaultValue: title?.['id-ID'],
        // validate: Yup.string().required(translate("must-be-provided")),
      },
      {
        name: 'titleFR',
        defaultValue: title?.['fr-FR'],
        // validate: Yup.string().required(translate("must-be-provided")),
      },
      {
        name: 'titleES',
        defaultValue: title?.['es-ES'],
        // validate: Yup.string().required(translate("must-be-provided")),
      },
      {
        name: 'image',
        defaultValue: { file: { name: image }, src: image },
        validate: Yup.string().required(translate('must-be-provided')),
      },
      {
        name: 'expirationDate',
        defaultValue: expirationDate,
        validate: Yup.string().required(translate('must-be-provided')),
      },
    ],
    onSubmit: async (values) => {
      const {
        announcementId,
        titleEN,
        titleVI,
        titleKO,
        titleZH,
        titleHI,
        titleID,
        titleFR,
        titleES,
        image,
        expirationDate,
      } = values;
      return ConfigService.editAnnouncement(announcementId, {
        title: {
          'en-US': titleEN,
          'vi-VN': titleVI,
          'ko-KR': titleKO,
          'zh-CN': titleZH,
          'hi-IN': titleHI,
          'id-ID': titleID,
          'fr-FR': titleFR,
          'es-ES': titleES,
        },
        content: newContent,
        image: image?.src,
        expirationDate: moment(expirationDate).toISOString(),
      })
        .then(() => {
          CreateAlert({
            message: 'Update success.',
            type: 'success',
          });
          navigate(Routes.Announcement.path);
        })
        .catch((error: any) => {
          CreateAlert({
            message: translate(error.message),
            type: 'danger',
          });
        });
    },
  });

  return (
    <>
      <h1 className='mb40'>Edit Announcement</h1>
      <form className='Edit' onSubmit={handleSubmit}>
        <InputWraper
          label={translate('Announcement ID')}
          inputProps={getInputProps('announcementId')}
          component={InputText}
        />
        <Tabs
          tabs={[
            {
              label: 'English',
              id: 'titleEN',
              subId: 'en-US',
            },
            {
              label: 'Vietnamese',
              id: 'titleVI',
              subId: 'vi-VN',
            },
            {
              label: 'Korean',
              id: 'titleKO',
              subId: 'ko-KR',
            },
            {
              label: 'Chinese',
              id: 'titleZH',
              subId: 'zh-CN',
            },
            {
              label: 'Hindi',
              id: 'titleHI',
              subId: 'hi-IN',
            },
            {
              label: 'Indonesian',
              id: 'titleID',
              subId: 'id-ID',
            },
            {
              label: 'French',
              id: 'titleFR',
              subId: 'fr-FR',
            },
            {
              label: 'Spanish',
              id: 'titleES',
              subId: 'es-ES',
            },
          ]}
          render={(tab) => {
            return (
              <>
                <InputWraper
                  label={'Title'}
                  inputProps={getInputProps(tab.id)}
                  component={InputText}
                />
                <EditorForm
                  title='Content'
                  dataDefault={newContent[`${tab.subId}`]}
                  getData={(data: any) => {
                    setNewContent((state: any) => {
                      state[`${tab.subId}`] = data;
                      return state;
                    });
                  }}
                />
              </>
            );
          }}
        ></Tabs>

        <InputWraper
          label={'Image'}
          inputProps={getInputProps('image')}
          component={InputImageSingle}
          className='mr5'
        />
        <InputWraper
          label={translate('Expiration Date')}
          inputProps={getInputProps('expirationDate')}
          component={InputDateTime}
          className='ml5'
        />
        <div>
          <Button
            label='Update'
            isMiddle
            buttonType='success'
            className='btnBan'
            type='submit'
            disabled={newContent['en-US'] === ''}
            isLoading={isSubmitting}
          />
        </div>
      </form>
    </>
  );
};
